import React from 'react';

export default function Logo({ size = 38 }) {
  return (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <polygon points="40,10 70,36 70,70 10,70 10,36" fill="#1e9bd0" opacity="0.95"/>
      <polygon points="40,6 74,36 6,36" fill="#ffffff" opacity="0.95"/>
      <rect x="31" y="50" width="18" height="20" rx="2" fill="#0d5c8a"/>
      <rect x="34" y="38" width="12" height="10" rx="1" fill="#fff" opacity="0.9"/>
      <line x1="40" y1="38" x2="40" y2="48" stroke="#b0d8f0" strokeWidth="1"/>
      <line x1="34" y1="43" x2="46" y2="43" stroke="#b0d8f0" strokeWidth="1"/>
      <g transform="translate(5,48) rotate(-35,14,22)">
        <rect x="11" y="10" width="6" height="22" rx="3" fill="#f5a623"/>
        <circle cx="14" cy="9" r="5" fill="none" stroke="#f5a623" strokeWidth="2.5"/>
        <rect x="9" y="6" width="10" height="6" fill="#f5a623"/>
      </g>
      <g transform="translate(54,8)">
        <path d="M4,18 Q14,-2 22,2 Q18,14 4,18Z" fill="#2db55d"/>
        <line x1="4" y1="18" x2="18" y2="5" stroke="#1a8a3e" strokeWidth="1" strokeLinecap="round"/>
      </g>
      <circle cx="16" cy="16" r="4" fill="#f5c842" opacity="0.9"/>
      <line x1="16" y1="8" x2="16" y2="11" stroke="#f5c842" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="22" y1="10" x2="20" y2="12" stroke="#f5c842" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="24" y1="16" x2="21" y2="16" stroke="#f5c842" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="10" y1="10" x2="12" y2="12" stroke="#f5c842" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="8" y1="16" x2="11" y2="16" stroke="#f5c842" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
